import { AlphaBscCard } from "@/components/domain/AlphaBscCard";

export default function AlphaBscWatchlistPage() {
  return (
    <div className="space-y-4">
      <header>
        <h1 className="text-2xl font-semibold">Watchlist</h1>
        <p className="text-sm text-muted">
          Track Binance Alpha tokens trading on BSC DEXes (PancakeSwap V3 / Uniswap V3).
          Refreshed every 15 min from GeckoTerminal. Graduation score (0-100)
          weights liquidity, volume, vol/liq ratio, volume trend, transaction count.
          When a watched symbol appears on Binance USDT spot, status flips to
          'graduated' and (if auto-strategy is on) any open position is
          market-sold to capture the listing pump.
        </p>
      </header>
      <AlphaBscCard />
    </div>
  );
}
